export default () => {
    return [
        {
            path: '/customerService',
            name: 'customerService',
            component: () => import('./views/customerService.vue'),
        },
    ];
};
